(function () {
  paymentSummary.$inject = ["API_URL"];
  angular.module('calendarApp').directive('paymentSummary', paymentSummary);

  function paymentSummary(API_URL) {
    return {
      restrict: 'EA',
      replace: true,
      templateUrl: smooth.calendar_url + '/partials/directives/payment-summary.html',
      scope: {
        paymentState: '=',
        hasPaid: '@?'
      },
      link: function link(scope, elem, attrs) {
        scope.paymentMethods = {};
        scope.currencySettings = smooth.currencySettings;
        var paymentState = scope.paymentState;

        if (!scope.paymentState) {
          return;
        }

        var init = function init() {
          // Build a list of items that are being paid for
          scope.items = [];

          if (paymentState.paymentOptions.customerpackages && paymentState.paymentOptions.customerpackages.length) {
            var customerPackages = paymentState.paymentOptions.customerpackages;

            for (var i = 0; i < customerPackages.length; i++) {
              if (customerPackages[i].appointmentsPaidFor) {
                var item = 'your credit: ' + customerPackages[i].packageid.name;
                scope.items.push({
                  item: item,
                  cost: 0,
                  appointmentsPaidFor: customerPackages[i].appointmentsPaidFor,
                  quantity: 1,
                  total: 0
                });
              }
            }
          }

          if (paymentState.paymentOptions.packages && paymentState.paymentOptions.packages.length) {
            var packages = paymentState.paymentOptions.packages;

            for (var i = 0; i < packages.length; i++) {
              if (packages[i].purchased) {
                var total = (packages[i].purchased * packages[i].cost).toFixed(2);
                scope.items.push({
                  item: packages[i].name,
                  cost: packages[i].cost,
                  appointmentsPaidFor: packages[i].appointmentsPaidFor,
                  quantity: packages[i].purchased,
                  total: total
                });
              }
            }
          }

          if (paymentState.singleAppointments) {
            scope.items.push({
              item: 'Single Appointments',
              cost: paymentState.paymentOptions.singleappointmentcost,
              appointmentsPaidFor: paymentState.singleAppointments,
              quantity: paymentState.singleAppointments,
              total: (paymentState.singleAppointments * paymentState.paymentOptions.singleappointmentcost).toFixed(2)
            });
          }

          if (paymentState.workshopsPaidFor) {
            scope.items.push({
              item: 'Workshop',
              cost: paymentState.paymentOptions.workshopcost,
              appointmentsPaidFor: paymentState.workshopAppointments,
              quantity: paymentState.workshopsPaidFor,
              total: (paymentState.workshopsPaidFor * paymentState.paymentOptions.workshopcost).toFixed(2)
            });
          }

          scope.totalToPay = 0;
          scope.items.forEach(function (item) {
            scope.totalToPay += Number(item.total);
          });
        };

        init();
      }
    };
  }
})();